import { render, staticRenderFns } from "./GenerarGuia.vue?vue&type=template&id=56e13534&scoped=true&"
import script from "./GenerarGuia.vue?vue&type=script&lang=js&"
export * from "./GenerarGuia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e13534",
  null
  
)

export default component.exports